import React from 'react';
type PanelTransparencyContext = {
  panelIsTransparent?: boolean;
};

const {
  Provider: PanelTransparencyContextProvider,
  Consumer: PanelTransparencyContextConsumer,
} = React.createContext<PanelTransparencyContext>({});

export { PanelTransparencyContextProvider, PanelTransparencyContextConsumer };
